<template>
  <div>
    <div style="width:1000px">
      <el-form ref="form" label-width="120px">
        <el-form-item>
          <el-button size="small" @click="downTemplate()">1.下载模板</el-button>
        </el-form-item>
        <el-form-item>
          <el-upload
            ref="uploadExcel"
            v-model="form.filePath"
            :action="uploadUrl"
            :on-success="handleSuccess"
            :on-error="handleError"
            accept=".xls,.xlsx"
            multiple
            :limit="1"
            :headers="headers"
            :on-exceed="handleExceed"
            :before-upload="beforeUploadFile"
            :before-remove="beforeRemove"
            :on-remove="onRemove"
            :file-list="fileList"
          >
            <el-button size="small" plain>2.选择文件</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传1个模板文件(excel)，且不超过10M
            </div>
          </el-upload>
        </el-form-item>

        <el-form-item>
          <el-button @click="uploadFileView()">3.预览数据</el-button>
          <el-button
            type="primary"
            :disabled="isDisable"
            @click="sourceRelease()"
            >4.导入数据</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      show-footer
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="480"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
    >
      <vxe-table-column field="name" title="驾驶员姓名" min-width="120" />
      <vxe-table-column field="phone" title="联系方式" min-width="120" />
      <vxe-table-column field="password" title="密码" min-width="150" />
      <vxe-table-column field="workCompany" title="工作单位" min-width="150" />
      <vxe-table-column
        field="identificationNumber"
        title="身份证号"
        min-width="180"
      />
      <vxe-table-column
        field="idCardDueDateStr"
        title="身份证有效期"
        min-width="180"
      />
      <vxe-table-column field="provinceStr" title="省" min-width="160" />
      <vxe-table-column field="cityStr" title="市" min-width="130" />
      <vxe-table-column field="countyStr" title="区/县" min-width="180" />
      <vxe-table-column field="homeAddress" title="详细地址" min-width="150" />
      <vxe-table-column
        field="workLicense"
        title="道路运输从业资格证号"
        min-width="160"
      />
      <vxe-table-column
        field="workLicenseDueDateStr"
        title="道路运输从业资格证到期日期"
        min-width="210"
      />
      <vxe-table-column
        field="driverLicense"
        title="机动车驾驶证号"
        min-width="120"
      />
      <vxe-table-column
        field="driverLicenseDueDateStr"
        title="机动车驾驶证到期日期"
        min-width="160"
      />
      <vxe-table-column
        field="vehicleLicenseNumber"
        title="车辆牌照号"
        min-width="150"
      />
      <vxe-table-column
        field="vehicleLicenseColorStr"
        title="车牌颜色"
        min-width="150"
      />
      <vxe-table-column
        field="classificationCodeStr"
        title="车辆分类代码"
        min-width="150"
      />
      <vxe-table-column
        field="vehicleEnergyTypeStr"
        title="车辆能源类型"
        min-width="120"
      />
      <vxe-table-column
        field="totalWeightStr"
        title="车辆总重量(kg)"
        min-width="120"
      />
      <vxe-table-column
        field="loadWeightStr"
        title="车辆核定载质量(kg)"
        min-width="160"
      />
      <vxe-table-column field="lengthStr" title="车长(mm)" min-width="120" />
      <vxe-table-column field="widthStr" title="车宽(mm)" min-width="120" />
      <vxe-table-column
        field="heightStr"
        title="车辆高度(mm)"
        min-width="120"
      />
      <vxe-table-column field="owner" title="车辆所有人" min-width="150" />
      <vxe-table-column
        field="vehicleLicense"
        title="车辆行驶证档案编号"
        min-width="160"
      />
      <vxe-table-column
        field="vehicleLicenseDueDateStr"
        title="车辆行驶证到期日期"
        min-width="160"
      />
      <vxe-table-column
        field="roadTransportCertificateNumber"
        title="车辆道路运输证号"
        min-width="160"
      />
      <vxe-table-column
        field="roadTransportCertificateDateStr"
        title="道路运输许可证到期日期"
        min-width="180"
      />
      <vxe-table-column
        field="roadPermitNumber"
        title="道路运输经营许可证号"
        min-width="180"
      />
      <vxe-table-column
        field="isHasTrailerStr"
        title="是否挂车"
        min-width="100"
      />
      <vxe-table-column field="trailerNum" title="挂车车牌号" min-width="260" />
      <vxe-table-column
        field="trailerLicenseColorStr"
        title="挂车车牌颜色"
        min-width="260"
      />
      <vxe-table-column
        field="trailerClassificationCodeStr"
        title="挂车车辆类型"
        min-width="260"
      />
      <vxe-table-column
        field="trailerTotalWeight"
        title="挂车总质量(kg)"
        min-width="260"
      />
      <vxe-table-column
        field="trailerLoadWeight"
        title="挂车核定载质量(kg)"
        min-width="180"
      />
      <vxe-table-column
        field="trailerRoadTransport"
        title="挂车道路运输证"
        min-width="180"
      />
      <vxe-table-column
        field="vehicleClassStr"
        title="准驾车型"
        min-width="180"
      />
      <vxe-table-column
        field="issuingOrganizations"
        title="机动车驾驶证发证机关"
        min-width="160"
      />
      <vxe-table-column
        field="driverLicenseFromDateStr"
        title="机动车驾驶证有效期自"
        min-width="180"
      />
      <vxe-table-column field="vin" title="车辆识别码VIN" min-width="120" />
      <vxe-table-column
        field="useCharacter"
        title="车辆使用性质"
        min-width="120"
      />
      <vxe-table-column
        field="vehicleIssuingOrganizations"
        title="车辆行驶证发证机关"
        min-width="180"
      />
      <vxe-table-column
        field="vehicleRegisterDateStr"
        title="车辆行驶证注册日期"
        min-width="160"
      />
      <vxe-table-column
        field="vehicleIssueDateStr"
        title="车辆行驶证发证日期"
        min-width="160"
      />
      <vxe-table-column
        field="selfRespectStr"
        title="车身自重"
        min-width="150"
      />
      <vxe-table-column
        field="locationSourceStr"
        title="定位来源"
        min-width="150"
      />
      <vxe-table-column
        field="isLinkedStr"
        title="是否挂靠车辆"
        min-width="150"
      />
      <vxe-table-column
        field="roadPermitName"
        title="道路经营许可证业户名称"
        min-width="250"
      />
      <vxe-table-column
        v-if="isTaxOpen"
        field="realOwner"
        title="实际所有人"
        min-width="150"
      />
      <vxe-table-column
        v-if="isTaxOpen"
        field="realOwnerPhone"
        title="实际所有人联系方式"
        min-width="150"
      />
      <vxe-table-column
        v-if="isTaxOpen"
        field="brand"
        title="品牌"
        min-width="150"
      />
    </vxe-table>
  </div>
</template>
<script>
import request from "@/utils/request";
import { isTaxOpen } from "@/api/driver";
import { getToken } from "@/utils/auth";
export default {
  data() {
    return {
      isDisable: false,
      fileList: [],
      uploadUrl: this.BASE_API_URL + "ntocc-tps-api/fileUpload",
      tableData: [],
      headers: {
        Authorization: "Bearer " + getToken(),
        deviceId: "0000000000"
      },
      form: {
        filePath: "",
        isView: "2",
        type: "0",
        teamCode: ""
      },
      isTaxOpen: false
    };
  },
  created() {
    isTaxOpen().then(res => {
      this.isTaxOpen = res.data == 1 ? true : false;
      if (res.data == 1) {
        this.form.type = "3";
      }
    });
  },
  methods: {
    init() {
      this.isDisable = false;
      this.form.isView = 2;
      this.tableData = [];
      this.form.filePath = "";
      this.$refs.uploadExcel.clearFiles();
    },
    //上传文件预览
    uploadFileView() {
      if ("" == this.form.filePath) {
        return this.$message.warning("请先上传文件");
      }
      const rLoading = this.openLoading();
      request({
        url: `/ntocc-basic-api/driver/driverImportView`,
        params: { filePath: this.form.filePath, type: this.form.type },
        method: "post"
      }).then(response => {
        this.tableData = response.data;
        this.$message({ message: response.msg, type: "success" });
        this.form.isView = 1;
        rLoading.close();
      });
    },
    downTemplate() {
      request({
        url: `/ntocc-basic-api/driver/downTemplate`,
        params: { type: this.form.type },
        method: "get"
      }).then(response => {
        window.open(response.data);
      });
    },
    //导入实际承运人
    sourceRelease() {
      if ("" == this.form.filePath) {
        return this.$message.warning("请先上传文件");
      }
      if (1 != this.form.isView) {
        return this.$message.warning(
          "请先预览后，再导入数据，并且不能重复导入"
        );
      }
      this.isDisable = true;
      const rLoading = this.openLoading();
      request({
        url: `/ntocc-basic-api/driver/driverImport`,
        params: {
          filePath: this.form.filePath,
          isView: this.form.isView,
          type: this.form.type,
          teamCode: this.form.teamCode
        },
        method: "post"
      }).then(response => {
        this.form.isView = 2;
        this.$message({ message: response.msg, type: "success" });
        this.isDisable = false;
        rLoading.close();
      });
    },
    // 上传成功回调
    handleSuccess(res, file) {
      if (res.status == 500) {
        this.$message.error(res.msg);
      } else {
        this.$message({ message: res.msg, type: "success" });
        this.form.filePath = res.data;
      }
    },
    //上传前校验
    beforeUploadFile(file) {
      let extension = file.name.substring(file.name.lastIndexOf(".") + 1);
      let size = file.size / 1024 / 1024;
      if (extension !== "xls" && extension !== "xlsx") {
        this.$message.error("只能上传excel文件");
        return false;
      }
      if (size > 10) {
        this.$message.error("上传文件大小不能超过 10MB!");
        return false;
      }
      // 获取token值，实时获取
      this.headers.Authorization = "Bearer " + getToken();
      return true;
    },

    // 文件上传失败时的钩子
    handleError(err, file, fileList) {
      this.$notify.error({
        title: "错误",
        message: `文件上传失败`
      });
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    onRemove(file, fileList) {
      this.form.isView = 2;
      this.tableData = [];
      this.form.filePath = "";
      this.isDisable = false;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    }
  }
};
</script>
<style></style>
